import axios from "axios";

export const api = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (
        error.response.data.error === "Invalid token" ||
        error.response.data.error === "Authentication required"
      ) {
        window.location.href = "/login";
        localStorage.removeItem("token");
      }
      throw new Error(error.response.data.error || "An error occurred");
    } else if (error.request) {
      console.error("Request error:", error.request);
      throw new Error("No response received from server");
    } else {
      console.error("Error:", error.message);
      throw new Error("Error setting up request");
    }
  }
);
